import { createContext, useContext, useEffect, useState } from "react";
import { getStripeAccessStatus } from "../api/apiFunctions";

const SubscriptionAccessContext = createContext();

export function SubscriptionAccessProvider({ children }) {
  const [hasAccess, setHasAccess] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState("never");

  useEffect(() => {
    const getSubscriptionAccess = async () => {
      const token =
        localStorage.getItem("authToken") ||
        sessionStorage.getItem("authToken");
      try {
        const response = await getStripeAccessStatus(token);
        if (response.success) {
          setHasAccess(response.access);
        }
      } catch (error) {
        console.error("Error fetching subscription access:", error);
      }
    };
    getSubscriptionAccess();
  }, []);

  const dontHaveAccess = !hasAccess;

  return (
    <SubscriptionAccessContext.Provider
      value={{
        dontHaveAccess,
        hasAccess,
        setHasAccess,
        subscriptionStatus,
        setSubscriptionStatus,
      }}
    >
      {children}
    </SubscriptionAccessContext.Provider>
  );
}

export function useSubscriptionAccess() {
  return useContext(SubscriptionAccessContext);
}
